import type { InputHTMLAttributes } from 'react';
import { useId } from 'react';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  error?: string;
  hint?: string;
};

export function FormField({ label, error, hint, style, id, ...rest }: Props) {
  const autoId = useId();
  const fieldId = id ?? autoId;
  return (
    <div style={{ marginBottom: 16, display: 'flex', flexDirection: 'column' }}>
      <label
        htmlFor={fieldId}
        style={{
          fontSize: 14,
          color: 'var(--muted)',
          marginBottom: 4,
          fontWeight: 500,
        }}
      >
        {label}
      </label>
      <input
        id={fieldId}
        {...rest}
        style={{
          minHeight: 48,
          padding: '12px 16px',
          background: 'var(--surface)',
          border: `1px solid ${error ? 'var(--error)' : 'var(--border)'}`,
          borderRadius: 12,
          fontSize: 16,
          color: 'var(--ink)',
          outline: 'none',
          fontFamily: 'inherit',
          ...style,
        }}
      />
      {error ? (
        <span style={{ marginTop: 4, color: 'var(--error)', fontSize: 14 }}>{error}</span>
      ) : hint ? (
        <span style={{ marginTop: 4, color: 'var(--muted)', fontSize: 14 }}>{hint}</span>
      ) : null}
    </div>
  );
}
